import {
  Flex,
  Box,
  Heading,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
} from "@chakra-ui/react"
import ViataSiSomaj from "./ViataSiSomaj"
import DauneElectrice from "./DauneElectrice"
import InstalatieElectricaSanitara from "./InstalatieElectricaSanitara"

const InsuranceTypes = () => {
  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center">
      <Box
        backgroundImage={[
          "url(/cez-confort-asigurat/assets/confortul-de-acasa-mobile.jpg)",
          "url('/cez-confort-asigurat/assets/confortul-de-acasa.jpg')",
          "url('/cez-confort-asigurat/assets/confortul-de-acasa.jpg')",
          "url('/cez-confort-asigurat/assets/confortul-de-acasa.jpg')",
        ]}
        backgroundPosition={["right", "center", "center", "center"]}
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        height="50vh"
        width={["80vw", "80vw", "60vw", "60vw"]}
        borderRadius="4px"
      />
      <Flex
        width={["75vw", "75vw", "55vw", "55vw"]}
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        paddingTop="24px"
        paddingBottom="24px"
        marginBottom="24px"
        marginTop="-48px"
        boxShadow="lg"
        backgroundColor="white"
      >
        <Flex
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          paddingLeft="16px"
          paddingRight="16px"
        >
          <Heading textAlign="center">
            Avem grija de confortul tau de acasa, chiar si in situatiile
            neprevazute
          </Heading>
        </Flex>
        <Flex
          flexDirection={["column", "column", "row", "row"]}
          justifyContent="space-evenly"
        >
          <Tabs
            marginTop="16px"
            marginBottom="16px"
            colorScheme="brand"
            align="center"
            width={["75vw", "75vw", "55vw", "55vw"]}
          >
            <TabList height="80px">
              <Tab fontSize="sm" width={`${100 / 3}%`}>
                Asigurare de viata si somaj
              </Tab>
              <Tab fontSize="sm" width={`${100 / 3}%`}>
                Protectie impotriva daunelor electrice
              </Tab>
              <Tab fontSize="sm" width={`${100 / 3}%`}>
                Asistenta de urgenta
              </Tab>
            </TabList>
            <TabPanels>
              <TabPanel padding={["16px", "16px", "24px", "48px"]}>
                <ViataSiSomaj />
              </TabPanel>
              <TabPanel padding={["16px", "16px", "24px", "48px"]}>
                <DauneElectrice />
              </TabPanel>
              <TabPanel padding={["16px", "16px", "24px", "48px"]}>
                <InstalatieElectricaSanitara />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Flex>
      </Flex>
    </Flex>
  )
}

export default InsuranceTypes
